export const MAP_SET_MAP_IMAGE = 'MAP_SET_MAP_IMAGE';
export const MAP_SET_CLICK_ACTION = 'MAP_SET_CLICK_ACTION';
export const MAP_ADD_MARKER = 'MAP_ADD_MARKER';
export const MAP_MARKER_SET_SECU_TYPE = 'MAP_MARKER_SET_SECU_TYPE';
export const MAP_MARKER_SET_LAYER = 'MAP_MARKER_SET_LAYER';
export const MAP_LAYER_SET_VISIBLE = 'MAP_LAYER_SET_VISIBLE';
export const MAP_ADD_LAYER = 'MAP_ADD_LAYER';